import * as React from 'react';
import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api';
import { WebSocketClient } from '@cian/chats-api/lib/browser-entry';
import { ILogger } from '@cian/logger/shared';

export interface IChatsNotificationsContext {
  logger: ILogger;
  httpApi: IHttpApi;
  socket: WebSocketClient;
}

export const ChatsNotificationsContext = React.createContext<IChatsNotificationsContext | null>(null);
